/**
 * Share images (og:image / twitter:image), built the way server.js builds them.
 *
 * server.js writes the share-image tags crawlers and link previews read. On the
 * URL a visitor lands on, index.html's dedupe script keeps those and deletes the
 * copies react-helmet adds; after an in-app navigation Helmet's copies replace
 * them. So the two must agree, or a page's share image changes once the visitor
 * clicks through the site. Until 2026-10-06 they didn't: the article page used
 * its relative WebP featured_image, and many tool pages pointed at /images/og-*.jpg
 * files that the server never serves (that path belongs to the image gallery).
 *
 * toPublicUrl is a copy of the function of the same name in server.js, and
 * articleShareImage mirrors its generateMetaTags. Keep them identical.
 */

// What server.js's catch-all route writes for every page without its own image.
export const SITE_SHARE_IMAGE = 'https://savedelete.com/logo512.png';

// Media URLs built against the internal API host (server-side fetches) belong on
// the public site.
const INTERNAL_ORIGINS = /^https?:\/\/(api|localhost|127\.0\.0\.1)(:\d+)?/i;

function toPublicUrl(u: string): string {
  if (INTERNAL_ORIGINS.test(u)) return u.replace(INTERNAL_ORIGINS, 'https://savedelete.com');
  if (u.startsWith('http')) return u;
  return `https://savedelete.com${u.startsWith('/') ? '' : '/'}${u}`;
}

// og_image is the JPEG/PNG the API derives for sharing; featured_image is the WebP
// shown on the page, which Twitter and LinkedIn render poorly.
export function articleShareImage(article: { og_image?: string | null; featured_image?: string | null }): string {
  return toPublicUrl(article.og_image || article.featured_image || '/logo512.png');
}
